// Generated from SVG to Code Figma Plugin

export const BaseLineDuration = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11.6016 7V12" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    <path
      d="M14.6016 15L11.6016 12"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <circle cx="11.9984" cy="12.0004" r="9.6" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);
